import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import styles from './attendee-list-sub-item.css'

const AttendeeListSubItem = ({ email, name, phoneNumber, ticketCount, ticketType }) => (
  <div styleName="attendee-list-sub-item">
    <Relayout gutter={false}>
      <RelayoutItem sm="12" lg="4">
        <div styleName="name">
          {name}
          <div styleName="name-contact">{_.compact([email, phoneNumber]).join(' • ')}</div>
        </div>
      </RelayoutItem>

      <RelayoutItem sm="10" lg="3">
        <div styleName="list-ticket-type">
          {ticketType.map((type, i) => <div styleName="ticket-type" key={i}>{type}</div>)}
        </div>
      </RelayoutItem>

      <RelayoutItem sm="2" lg="2">
        <div styleName="list-ticket-count">
          {ticketCount.map((count, i) => <div styleName="ticket-count" key={i}>{count}</div>)}
        </div>
      </RelayoutItem>

      <RelayoutItem sm="0" lg="3">
        <div styleName="contact">
          {email}
          {email && phoneNumber && <br />}
          {phoneNumber}
        </div>
      </RelayoutItem>
    </Relayout>
  </div>
)

AttendeeListSubItem.propTypes = {
  email: PropTypes.string,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  ticketCount: PropTypes.array,
  ticketType: PropTypes.array,
}

export default CSSModules(AttendeeListSubItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/attendee-list-sub-item/attendee-list-sub-item.js
 **/